import type { IconProps } from "../components/Icon"

export interface HeaderTab {
  href: string
  text: string
}

export interface HeaderStore {
  tabs: HeaderTab[]
  icon: IconProps | null
  searchWorksheets: string
}

export const headerStore: HeaderStore = {
  tabs: [],
  icon: null,
  searchWorksheets: "",
}
